import { c as _c } from "react/compiler-runtime";
import { MultiSelectConditionPanel } from '@/components/conditions/conditionComponents';
import { Icon } from '@/components/shared/icon';
import type { MultiSelectConditionComponentProps } from '@/types/advanceFilter';
import { DETECTOR_OPTIONS, SECURITY_SCAN_CONCLUSION_OPTIONS } from './detectorOptions';
const detectorTypeOptions = DETECTOR_OPTIONS.map(({
  id,
  name,
  icon
}) => ({
  id,
  name,
  Image: <Icon iconClass={icon} />
}));
const threatFindingOptions = SECURITY_SCAN_CONCLUSION_OPTIONS.map(({
  id,
  name,
  icon
}) => ({
  id,
  name,
  Image: <Icon iconClass={icon} />
}));
export const DetectionCategoryCondition = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MultiSelectConditionPanel {...props} showAddNewButton={false} showSearchBox={false} isLoading={false} entityName="detection category" options={detectorTypeOptions} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const ThreatFindingCondition = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MultiSelectConditionPanel {...props} showAddNewButton={false} showSearchBox={false} isLoading={false} entityName="threat finding" options={threatFindingOptions} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};